import mod from "-!./help.js?vue&type=script&lang=js&"; export default mod; export * from "-!./help.js?vue&type=script&lang=js&"